import { Box } from '@mui/material';

import { Typography } from '@occc/ui-design-system';
import { Switches, TextField } from '@occc-app/design-system';

export const TotalAvailableRollbackConfiguration = () => {
  return (
    <Box mt={3}>
      <Box
        p={3}
        mb={3}
        borderRadius={4}
        display='flex'
        alignItems='center'
        justifyContent='space-between'
        sx={(theme) => ({
          border: 1,
          borderColor: theme.palette.grey[300],
        })}
      >
        <Box display='flex' flexDirection='column'>
          <Typography variant='h6'>Product Group Rank</Typography>
          <Typography variant='body2' color='textSecondary'>
            The rank of this product group in the list of fuel grades in Experience. Lower numbers
            will appear higher in the list
          </Typography>
        </Box>
        <TextField
          sx={{ marginLeft: 1, width: 164 }}
          label='Set Rank'
          name='sortingRank'
          type='number'
        />
      </Box>
      <Box
        p={3}
        borderRadius={4}
        display='flex'
        alignItems='center'
        justifyContent='space-between'
        sx={(theme) => ({
          border: 1,
          borderColor: theme.palette.grey[300],
        })}
      >
        <Box display='flex' flexDirection='column'>
          <Typography variant='h6'>Default for Total Available Rollback</Typography>
          <Typography variant='body2' color='textSecondary'>
            Set this product group as the default for all members when calculating Total Available
            Rollback
          </Typography>
        </Box>
        <Switches name='default' data={{}} />
      </Box>
    </Box>
  );
};
